<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="5" class="pr-1 pl-1">
                    <input type="text" placeholder="Tipe Kategori" v-model="searchKelompok" class="form-control"/>
                </CCol>
                <CCol sm="5" class="pr-1 pl-1">
                    <input type="text" placeholder="Deskripsi" v-model="searchKeterangan" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Kategori Tidak Hadir</label>
                        <input 
                            class="form-control mr-2" 
                            v-model.trim="$v.keterangan.$model"
                            :class="{ 'is-invalid':$v.keterangan.$error, 'is-valid': !$v.keterangan.$invalid }"
                            placeholder="Nama" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6" v-if="tipe == 'C'">
                        <label>Tipe Kategori Tidak Hadir</label>
                        <model-select :options="dataKelompok"
                            class="form-control model-select"
                            v-model.trim="$v.kelompok.$model"
                            :class="{ 'is-invalid select-invalid':$v.kelompok.$error, 'is-valid select-valid': !$v.kelompok.$invalid }"
                            placeholder="Pilih Tipe">
                        </model-select>
                    </CCol>
                    <CCol sm="6" v-else>
                        <label>Kode Kategori Tidak Hadir</label>
                        <input 
                            class="form-control mr-2" 
                            style="background-color:whitesmoke"
                            disabled
                            v-model="kodeTipe"
                            placeholder="Tipe" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Status</label>
                        <model-select :options="dataAktif"
                            class="form-control model-select"
                            v-model.trim="$v.isActive.$model"
                            :class="{ 'is-invalid select-invalid':$v.isActive.$error, 'is-valid select-valid': !$v.isActive.$invalid }"
                            placeholder="Pilih Status">
                        </model-select>
                    </CCol>
                    <CCol sm="6" v-if="tipe != 'C'">
                        <label>Tipe Kategori Tidak Hadir</label>
                        <input 
                            class="form-control mr-2" 
                            style="background-color:whitesmoke"
                            v-model="kategoriTipe"
                            disabled
                            placeholder="Tipe" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="2">
                        <label>Kuota (Hari)</label>
                        <input 
                            class="form-control mr-2" 
                            v-model.trim="$v.kuota.$model"
                            :class="{ 'is-invalid':$v.kuota.$error, 'is-valid': !$v.kuota.$invalid }"
                            :disabled="isUnlimited == 1"
                            placeholder="Kuota" 
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="4" >
                        <label>Periode Diperbaharui (reset)</label>
                        <model-select :options="dataPeriodeDiperbaharui"
                            class="form-control model-select"
                            :isDisabled="isUnlimited == 1"
                            v-model.trim="$v.periodeDiperbaharui.$model"
                            :class="{ 'is-invalid select-invalid':$v.periodeDiperbaharui.$error, 'is-valid select-valid': !$v.periodeDiperbaharui.$invalid }"
                            placeholder="Pilih Periode Diperbaharui">
                        </model-select>
                    </CCol>
                    <CCol sm="2" >
                        <label>Nominal Periode</label>
                        <input 
                            class="form-control mr-2" 
                            v-model.trim="$v.nominalPeriode.$model"
                            :disabled="isUnlimited == 1"
                            :class="{ 'is-invalid':$v.nominalPeriode.$error, 'is-valid': !$v.nominalPeriode.$invalid }"
                            placeholder="Nominal Periode" 
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="4" >
                        <label>Satuan Periode</label>
                        <model-select :options="dataSatuanPeriode"
                            class="form-control model-select"
                            :isDisabled="isUnlimited == 1"
                            v-model.trim="$v.satuanPeriode.$model"
                            :class="{ 'is-invalid select-invalid':$v.satuanPeriode.$error, 'is-valid select-valid': !$v.satuanPeriode.$invalid }"
                            placeholder="Pilih Satuan Periode">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="4">
                        <div>
                            <input type="checkbox" id="isUnlimited" name="isUnlimited" @change="checkUnlimited()" :checked="isUnlimited == 1">
                            <label class="ml-2" for="isUnlimited">Kuota Unlimited</label>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Jenis Kelamin</label>
                        <model-select :options="dataJenisKelamin"
                            class="form-control model-select"
                            v-model.trim="$v.jenisKelamin.$model"
                            :class="{ 'is-invalid select-invalid':$v.jenisKelamin.$error, 'is-valid select-valid': !$v.jenisKelamin.$invalid }"
                            placeholder="Pilih Jenis Kelamin">
                        </model-select>
                    </CCol>
                    <CCol sm="6" >
                        <label>Status Pegawai</label>
                        <model-select :options="dataStatusPegawai"
                            class="form-control model-select"
                            v-model.trim="$v.statusPegawai.$model"
                            :class="{ 'is-invalid select-invalid':$v.statusPegawai.$error, 'is-valid select-valid': !$v.statusPegawai.$invalid }"
                            placeholder="Pilih Status Pegawai">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Status Anak</label>
                        <model-select :options="dataStatusAnak"
                            class="form-control model-select"
                            v-model.trim="$v.statusAnak.$model"
                            :class="{ 'is-invalid select-invalid':$v.statusAnak.$error, 'is-valid select-valid': !$v.statusAnak.$invalid }"
                            placeholder="Pilih Status Anak">
                        </model-select>
                    </CCol>
                    <CCol sm="6" >
                        <label>Status Hitungan Hari</label>
                        <model-select :options="dataStatusHari"
                            class="form-control model-select"
                            v-model.trim="$v.statusHari.$model"
                            :class="{ 'is-invalid select-invalid':$v.statusHari.$error, 'is-valid select-valid': !$v.statusHari.$invalid }"
                            placeholder="Pilih Status Hari">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6" >
                        <label>Agama</label>
                        <model-select :options="dataAgama"
                            class="form-control model-select"
                            v-model.trim="$v.agama.$model"
                            :class="{ 'is-invalid select-invalid':$v.agama.$error, 'is-valid select-valid': !$v.agama.$invalid }"
                            placeholder="Pilih Agama">
                        </model-select>
                    </CCol>
                    <CCol sm="6" >
                        <label>Syarat Pengajuan</label>
                        <model-select :options="dataIsLeave"
                            class="form-control model-select"
                            v-model.trim="$v.isLeave.$model"
                            :class="{ 'is-invalid select-invalid':$v.isLeave.$error, 'is-valid select-valid': !$v.isLeave.$invalid }"
                            placeholder="Pilih Syarat Pengajuan">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6" >
                        <label>File Pendukung</label>
                        <model-select :options="dataFilePendukung"
                            class="form-control model-select"
                            v-model.trim="$v.filePendukung.$model"
                            :class="{ 'is-invalid select-invalid':$v.filePendukung.$error, 'is-valid select-valid': !$v.filePendukung.$invalid }"
                            placeholder="Pilih File Pendukung">
                        </model-select>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tablePresensi'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
export default {
    components: {
        ModelSelect,
        Tables
    },
    mixins: [validationMixin],
    validations: {
        kelompok: {
            text: {
                required
            },
            value: {
                required
            }
        },
        keterangan: {
            required
        },
        isActive: {
            text: {
                required
            },
            value: {
                required
            }
        },
        kuota: {
            required
        },
        nominalPeriode: {
            required
        },
        satuanPeriode: {
            text: {
                required
            },
            value: {
                required
            }
        },
        jenisKelamin: {
            text: {
                required
            },
            value: {
                required
            }
        },
        statusPegawai: {
            text: {
                required
            },
            value: {
                required
            }
        },
        statusAnak: {
            text: {
                required
            },
            value: {
                required
            }
        },
        filePendukung: {
            text: {
                required
            },
            value: {
                required
            }
        },
        statusHari: {
            text: {
                required
            },
            value: {
                required
            }
        },
        periodeDiperbaharui: {
            text: {
                required
            },
            value: {
                required
            }
        },
        agama: {
            text: {
                required
            },
            value: {
                required
            }
        },
        isLeave: {
            text: {
                required
            },
            value: {
                required
            }
        }
    },
    data() {
        return {
            success: true,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['Nama', 'Deskripsi', 'Kuota', 'Periode', 'Diperbaharui', 'Jenis Kelamin', 'Menikah', 'Anak', 'File', 'Status', 'Action'],
            dataTd: ['kelompok', 'keterangan', 'kuota', 'satuanPeriode', 'periodeReset', 'kelamin', 'maritalStatus', 'statusAnak', 'mandatoryFile', 'isActive', 'action'],
            styleTable: ['75px', '125px', '75px', '75px', '100px', '100px', '100px', '100px', '75px', '75px', '100px'],
            classReload: 'reloadOff',
            datas: [],
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            isActive: {
                text: '',
                value: ''
            },
            satuanPeriode: {
                text: '',
                value: ''
            },
            jenisKelamin: {
                text: '',
                value: ''
            },
            statusPegawai: {
                text: '',
                value: ''
            },
            statusAnak: {
                text: '',
                value: ''
            },
            filePendukung: {
                text: '',
                value: ''
            },
            statusHari: {
                text: '',
                value: ''
            },
            periodeDiperbaharui: {
                text: '',
                value: ''
            },
            agama: {
                text: '',
                value: ''
            },
            isLeave: {
                text: '',
                value: ''
            },
            dataSatuanPeriode: [],
            dataJenisKelamin: [],
            dataStatusPegawai: [],
            dataStatusAnak: [],
            dataFilePendukung: [],
            dataStatusHari: [],
            dataPeriodeDiperbaharui: [],
            dataAgama: [],
            dataIsLeave: [],
            dataAktif: [],
            dataKelompok: [],
            kelompok: {
                text: '',
                value: ''
            },
            keterangan: '',
            kode: "",
            unix: "",
            tipe: 'C',
            kodeTipe: '',
            kategoriTipe: '',
            kuota: '',
            nominalPeriode: '',
            isUnlimited: 0,

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchKelompok: '',
            searchKeterangan: '',
            // error
            errorMessage: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchKelompok() {
            this.flagSearch = true
        },
        searchKeterangan() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    computed: {
    },
    methods: {
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kode.toLowerCase() < b.kode.toLowerCase()) {
                        return -1
                    }
                    if (a.kode.toLowerCase() > b.kode.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.kelompok.toLowerCase() < b.kelompok.toLowerCase()) {
                        return -1
                    }
                    if (a.kelompok.toLowerCase() > b.kelompok.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.keterangan.toLowerCase() < b.keterangan.toLowerCase()) {
                        return -1
                    }
                    if (a.keterangan.toLowerCase() > b.keterangan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let kelompok = this.searchKelompok
            let keterangan = this.searchKeterangan
            let payload = {
                kelompok: kelompok,
                keterangan: keterangan,
                kode: '',
                limit: this.size,
                pageIn: this.page
            }
            DataApi.post("absensi/backoffice/tidak_masuk_lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchKelompok = ''
            this.searchKeterangan = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.kode = ''
                this.keterangan = ''
                this.isActive.text = ''
                this.isActive.value = ''
                this.kelompok.text = ''
                this.type = 0
                this.kelompok.value = ''
                this.kodeTipe = ''
                this.kategoriTipe = ''
                this.tipe = 'C'
                this.getDataAktif()
                this.getDataKelompok()
                this.getDataDefault()
                this.$v.$reset()
            }
        },
        goSave() {
            let isActive = this.isActive.value
            let kelompok = ''
            let kode = ''
            if(this.tipe == 'C') {
                kelompok = this.kelompok.text
                kode = this.kelompok.value
            } else {
                kelompok = this.kategoriTipe
                kode = this.kodeTipe
            }
            

            let keterangan = this.keterangan
            let tipe = this.tipe
            let unix = this.unix

            let payload = {
                isActive: isActive,
                jumlahPeriode: this.isUnlimited == 1 ? '0' : this.nominalPeriode,
                kelamin: this.jenisKelamin.value,
                kelompok: kelompok,
                keterangan: keterangan,
                kode: kode,
                kuota: this.isUnlimited == 1 ? '0' : this.kuota,
                mandatoryFile: this.filePendukung.value,
                maritalStatus: this.statusPegawai.value,
                periodeReset: this.isUnlimited == 1 ? '0' : this.periodeDiperbaharui.value,
                satuanPeriode: this.isUnlimited == 1 ? '0' : this.satuanPeriode.value,
                statusAnak: this.statusAnak.value,
                statusHari: this.statusHari.value,
                isLeave: this.isLeave.value,
                tipe: tipe,
                unix: unix,
                agama: this.agama.value
            }
            DataApi.post("absensi/backoffice/tidak_masuk_simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            let unlimited = generate.kuota == '0' ? true : false
            this.kodeTipe = generate.kode
            this.kategoriTipe = generate.kelompok
            this.keterangan = generate.keterangan
            this.unix = generate.unix

            let isActive = generate.isActive
            let data = this.dataAktif

            var i = 0
            for(i=0;i<data.length;i++) {
                if(isActive == data[i].value) {
                    this.isActive.text = data[i].text
                    this.isActive.value = data[i].value
                }
            }
            this.kuota = unlimited ? '' : generate.kuota,
            this.nominalPeriode = unlimited ? '' : generate.jumlahPeriode

            let periodeReset = this.dataPeriodeDiperbaharui.find(({ value }) => value == generate.periodeReset)
            this.periodeDiperbaharui.value = periodeReset ? unlimited ? '' : periodeReset.value : ''
            this.periodeDiperbaharui.text = periodeReset ? unlimited ? '' : periodeReset.text : ''

            let satuanPeriode = this.dataSatuanPeriode.find(({ value }) => value == generate.satuanPeriode)
            this.satuanPeriode.value = satuanPeriode ? unlimited ? '' : satuanPeriode.value : ''
            this.satuanPeriode.text = satuanPeriode ?  unlimited ? '' : satuanPeriode.text : ''
            
            let kelamin = this.dataJenisKelamin.find(({ value }) => value == generate.kelamin)
            this.jenisKelamin.value = kelamin ? kelamin.value : ''
            this.jenisKelamin.text = kelamin ? kelamin.text : ''

            let mandatoryFile = this.dataFilePendukung.find(({ value }) => value == generate.mandatoryFile)
            this.filePendukung.value = mandatoryFile ? mandatoryFile.value : ''
            this.filePendukung.text = mandatoryFile ? mandatoryFile.text : ''

            let maritalStatus = this.dataStatusPegawai.find(({ value }) => value == generate.maritalStatus)
            this.statusPegawai.value = maritalStatus ? maritalStatus.value : ''
            this.statusPegawai.text = maritalStatus ? maritalStatus.text : ''

            let statusAnak = this.dataStatusAnak.find(({ value }) => value == generate.statusAnak)
            this.statusAnak.value = statusAnak ? statusAnak.value : ''
            this.statusAnak.text = statusAnak ? statusAnak.text : ''

            let statusHari = this.dataStatusHari.find(({ value }) => value == generate.statusHari)
            this.statusHari.value = statusHari ? statusHari.value : ''
            this.statusHari.text = statusHari ? statusHari.text : ''

            let agama = this.dataAgama.find(({ value }) => value == generate.agama)
            this.agama.value = agama ? agama.value : ''
            this.agama.text = agama ? agama.text : ''

            let isLeave = this.dataIsLeave.find(({ value }) => value == generate.isLeave)
            this.isLeave.value = isLeave ? isLeave.value : ''
            this.isLeave.text = isLeave ? isLeave.text : ''

            this.isUnlimited = unlimited ? 1 : 0

            this.tipe = 'u'
            this.moving()
        },
        submitForm() {
            this.$v.$touch()
            if(this.isUnlimited == 1) {
                if(this.$v.$invalid) {
                    this.$v.kuota.$reset()
                    this.$v.nominalPeriode.$reset()
                    this.$v.satuanPeriode.$reset()
                    this.$v.periodeDiperbaharui.$reset()

                    if(this.tipe != 'C') {
                        if(this.$v.kelompok.$invalid) {
                            this.goSave()
                            this.loading = true
                        }
                    } else {
                        this.goSave()
                        this.loading = true
                    }
                } else {
                    this.goSave()
                    this.loading = true
                }
            } else {
                if(this.$v.$invalid) {
                    if(this.tipe != 'C') {
                        if(this.$v.kelompok.$invalid) {
                            this.goSave()
                            this.loading = true
                        }
                    } else {
                        this.goSave()
                        this.loading = true
                    }
                } else {
                    this.goSave()
                    this.loading = true
                }
            }
        },
        getDataAktif() {
            this.dataAktif = [
                { value: '1', text: 'Aktif' },
                { value: '0', text: 'Tidak Aktif' }
            ]
        },
        getDataKelompok() {
            let payload = {
                keterangan: "",
                limit: 9999,
                pageIn: 1
            }
            DataApi.post("/tidakmasuk/tipe/lihat", payload)
            .then(res => {
                this.dataKelompok = []
                let response = res.data
                if(response.success == true) {
                    let datas = response.data.data
                    var i = 0
                    for(i=0;i<datas.length;i++) {
                        let onPush = {
                            value: datas[i].kode,
                            text: datas[i].keterangan
                        }
                        this.dataKelompok.push(onPush)
                    }
                }
            })
        },
        getDataDefault() {
            this.dataSatuanPeriode = [
                { value: 'B', text: 'Bulan' },
                { value: 'T', text: 'Tahun' },
            ],
            this.dataPeriodeDiperbaharui = [
                { value: '0', text: 'Awal Tahun Kalender(1 Januari)' },
                { value: '1', text: 'Tanggal Pemakaian' },
                { value: '2', text: 'Tanggal Awal Masuk Kontrak' }
            ],
            this.dataJenisKelamin = [
                { value: '0', text: 'Semua Jenis Kelamin' },
                { value: '2', text: 'Hanya untuk perempuan' },
                { value: '1', text: 'Hanya untuk laki-laki' },
            ],
            this.dataStatusPegawai = [
                { value: '0', text: 'Semua Status Pegawai' },
                { value: '1', text: 'Hanya untuk pegawai yang sudah menikah' },
                { value: '2', text: 'Hanya untuk pegawai yang belum menikah' },
            ],
            this.dataStatusAnak = [
                { value: '0', text: 'Semua Status Anak' },
                { value: '1', text: 'Hanya untuk yang sudah mempunyai anak' },
            ],
            this.dataFilePendukung = [
                { value: '1', text: 'Wajib menyertakan file pendukung' },
                { value: '0', text: 'Tidak wajib menyertakan file pendukung' }
            ],
            this.dataStatusHari = [
                { value: '0', text: 'Hari Kerja' },
                { value: '1', text: 'Hari Kalender' }
            ],
            this.dataAgama = [
                { value: '0', text: 'Semua Agama' },
                { value: 'Islam', text: 'Islam' },
                { value: 'Kristen', text: 'Kristen' },
                { value: 'Katholik', text: 'Katholik' },
                { value: 'Hindu', text: 'Hindu' },
                { value: 'Budha', text: 'Budha' },
                { value: 'Konghuchu', text: 'Konghuchu' },
            ],
            this.dataIsLeave = [
                { value: '0', text: 'Bebas, tidak ada aturan' },
                { value: '1', text: 'Dalam periode permohonan tidak ada permintaan leave' }
            ]
        },
        checkUnlimited() {
            let isUnlimited = document.getElementById("isUnlimited")
            if(isUnlimited.checked == true) {
                this.isUnlimited = 1
                this.kuota = ''
                this.periodeDiperbaharui.value = ''
                this.periodeDiperbaharui.text = ''
                this.satuanPeriode.value = ''
                this.satuanPeriode.text = ''
                this.nominalPeriode = ''
                this.dataPeriodeDiperbaharui = [
                    { value: '0', text: 'Awal Tahun Kalender(1 Januari)' },
                    { value: '1', text: 'Tanggal Pemakaian' },
                    { value: '2', text: 'Tanggal Awal Masuk Kontrak' }
                ],
                this.dataSatuanPeriode = [
                    { value: 'B', text: 'Bulan' },
                    { value: 'T', text: 'Tahun' },
                ],
                this.$v.kuota.$reset()
                this.$v.periodeDiperbaharui.$reset()
                this.$v.satuanPeriode.$reset()
                this.$v.nominalPeriode.$reset()
            } else {
                this.isUnlimited = 0
            }
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataAktif()
        this.getDataKelompok()
        this.getDataDefault()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}

.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
</style>
